@if (!icon) {
    <fui-filter-fascia (clicked$)="click()" [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                       [ngClass]="'clickable'">
        <fui-fixtures>
            <fui-fixture>
                <fui-mark-toggle [toggled]="popped">
                    <fui-icon [height]="12" [icon]="'chevron-down'" [width]="12"></fui-icon>
                </fui-mark-toggle>
            </fui-fixture>
            <fui-spanning-fixture>
                <fui-input-dom>
                    <input (blur)="onBlur($event)" [readonly]="true" #input (focus)="onFocus($event)"
                           [placeholder]="placeholder | translate" [tabindex]="tabindex" type="text">
                </fui-input-dom>
            </fui-spanning-fixture>
        </fui-fixtures>
    </fui-filter-fascia>
}
@if (icon) {
    <fui-action [forceIcon]="true" [attr.title]="placeholder | translate" (click)="click()" [disabled]="disabled">
        <ng-content select="fui-icon" ngProjectAs="fui-icon"></ng-content>
    </fui-action>
}
<fui-select-pop [popped]="popped" (popped$)="pop($event)">
    <fui-sections>
        <fui-section>
            <fui-multiselect-options [field]="field" [key]="key" [options]="options" id="options"
                                     [filteredOptions]="filteredOptions"
                                     (selections$)="select($event)"></fui-multiselect-options>
        </fui-section>
    </fui-sections>
</fui-select-pop>
